
import { Options, prop, Vue } from "vue-class-component";
import BookV3 from "./components/book-v3.vue";
import CheckTariffV2 from "@/app/ui/views/shipment/booking/create-booking-v3/components/footer/components/check-tariff.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { PromoConfigurationListRequest } from "@/data/payload/api/PromoConfigurationApiRequest";
import { PromoConfigurationController } from "@/app/ui/controllers/PromoConfigurationController";
import {
  PromoConfigurationList,
  PromoConfigurationListData
} from "@/domain/entities/PromoConfiguration";
import formatDateWithoutTime from "@/app/infrastructures/misc/common-library/FormatDateWithoutTime";
import WeightCost from "./components/weight-cost.vue";
import SelectPaymentMethods from "./payment/index.vue";
import SelectReceiptLanguage from "./language/index.vue";
import {
  EstimationPrice,
  Discount,
  DiscountTariff
} from "@/domain/entities/Booking";
import { SttAdjustmentRule } from "@/domain/entities/ShipmentBooking";
import { BookingV3 } from "@/domain/entities/CreateBookingV3";

class Props {
  modelValue = prop<BookingV3>({
    default: new BookingV3(),
    type: Object
  });
  id = prop<string>({
    default: "",
    type: String
  });
  isDisabled = prop<boolean>({
    required: true,
    default: false
  });
  formType = prop<string>({
    required: true
  });
  payload = prop<any>({
    required: true
  });
  isCodRetailApplied = prop<boolean>({
    required: true
  });
  totalPiece = prop<any>({
    default: "0"
  });
  totalGrossWeight = prop<any>({
    default: "0"
  });
  totalDimensionWeight = prop<any>({
    default: "0"
  });
  chargeableWeight = prop<any>({
    default: "0"
  });
  totalVolumeWeight = prop<any>({
    default: "0"
  });
  isCampaign = prop<boolean>({
    required: true
  });
  goodsValue = prop<any>({
    default: "0"
  });
  estimationPrice = prop<EstimationPrice>({
    required: true,
    type: EstimationPrice
  });
  isLoadingEstimation = prop<boolean>({
    default: false,
    type: Boolean
  });
  isErrorEstimation = prop<boolean>({
    default: false,
    type: Boolean
  });
  formCheckTariff = prop<any>({
    default: () => ({}),
    type: Object
  });
  idPaymentMethod = prop<string>({
    default: "",
    type: String
  });
  idReceiptLanguage = prop<string>({
    default: "",
    type: String
  });
  idWeightCost = prop<string>({
    default: "",
    type: String
  });
  idTariff = prop<string>({
    default: "",
    type: String
  });
  paymentMethod = prop<string>({
    default: "",
    type: String
  });
  productType = prop<string>({
    default: "",
    type: String
  });
  isValid = prop<boolean>({
    default: false,
    type: Boolean
  });
  adjustmentRuleTariff = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configShowPayment = prop<boolean>({
    default: true,
    type: Boolean
  });
  isButtonSubmit = prop<boolean>({
    default: true,
    type: Boolean
  });
  isEditSttMY = prop<boolean>({
    default: false
  });
  isCustomerApps = prop<boolean>({
    default: false
  });
  hidePaymentMethod = prop<boolean>({
    default: false
  });
  clientData = prop<any>({
    default: {},
    type: Object
  });
  isCrossCountryCod = prop<boolean>({ default: false, type: Boolean });
}

@Options({
  emits: ["setDiscount", "refresh", "submit", "update:paymentMethod"],
  components: {
    CheckTariffV2,
    BookV3,
    WeightCost,
    SelectPaymentMethods,
    SelectReceiptLanguage
  },
  watch: {
    "payload.productName": function() {
      this.checkDiscountActive();
      this.resetDiscount();
    },
    "payload.destinationCity": function() {
      this.checkDiscountActive();
      this.resetDiscount();
    },
    "payload.sttGrossWeight": function() {
      this.checkDiscountActive();
      this.resetDiscount();
    },
    "payload.sttVolumeWeight": function() {
      this.checkDiscountActive();
      this.resetDiscount();
    }
  }
})
export default class SectionFooterBookingV3 extends Vue.with(Props) {
  refreshCheckTariff() {
    this.$emit("refresh");
  }

  submitBookType(type: string) {
    this.$emit("submit", type);
  }

  get getRuleTariffDisabled() {
    return this.adjustmentRuleTariff.rule.includes("NON_EDITABLE");
  }

  get payment() {
    return this.paymentMethod;
  }
  set payment(value: string) {
    this.$emit("update:paymentMethod", value);
  }

  get isCreateBookingRetail() {
    return (
      this.formType === "manual" && AccountController.accountData.isAllPartner
    );
  }
  get isProductInterpack() {
    return this.payload.productName === "INTERPACK";
  }

  discount: Discount = {
    status: false,
    data: []
  };

  get validateDiscount() {
    return (
      this.payload.originCity &&
      this.payload.destinationCity &&
      this.payload.productName &&
      this.payload.sttGrossWeight > 0 &&
      this.formType === "manual" &&
      AccountController.accountData.isPosAccount
    );
  }

  async checkDiscountActive() {
    if (this.validateDiscount) {
      try {
        const promotion: PromoConfigurationList = await PromoConfigurationController.getPromoActive(
          new PromoConfigurationListRequest({
            page: 1,
            limit: 2,
            status: "active,nearly-expired",
            origin: this.payload.originCity,
            destination: this.payload.destinationCity,
            productName: this.payload.productName,
            grossWeight: this.payload.sttGrossWeight,
            volumeWeight: this.payload.sttVolumeWeight,
            chargeableWeight: this.payload.sttChargeableWeight,
            isTotalData: false,
            appliedTo: "retail"
          })
        );

        const promotionList = promotion.data;
        const isRetail = promotion.data[0].promoConfigurationAppliedTo.includes(
          "retail"
        );
        if (promotionList.length && isRetail) {
          this.discount = new Discount({
            status: true,
            data: promotionList.map((item: PromoConfigurationListData) => {
              return new PromoConfigurationListData({
                promoConfigurationName: `${
                  item.promoConfigurationName
                } sampai dengan ${formatDateWithoutTime(
                  item.promoConfigurationEndDate
                )}`,
                promoConfigurationDiscountNominal:
                  item.promoConfigurationDiscountNominal
              });
            })
          });
        } else {
          this.resetDiscountNominal();
        }
      } catch (err) {
        this.discount.status = false;
      }
    }
  }

  setDiscount(params: DiscountTariff) {
    this.$emit("setDiscount", params);
  }

  resetDiscount() {
    if (this.payload.sttGrossWeight <= 0 || this.payload.sttVolumeWeight <= 0) {
      this.resetDiscountNominal();
    }
  }

  resetDiscountNominal() {
    this.discount = new Discount();
  }

  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }
}
